// src/data/courses.js
export const courses = [
  {
    id: "School_year",
    title: "Year-Long FutureTech Program",
    shortDescriptionCover: "A structured annual curriculum combining drone technology, applied AI/ML",
    shortDescription: "A structured annual curriculum combining drone technology, applied AI/ML concepts, Python coding, and robotics . NEP-aligned, fully practical, and designed for future-ready skill building.",
    fullDescription:
      "Our comprehensive annual program offers progressive learning in drone technology, applied AI/ML, Python programming, robotics, and hands-on engineering. Fully aligned with NEP 2020, the curriculum ensures students build future-ready competencies through structured modules, real-world projects, and practical skill development throughout the academic year.",
    frequency: "Weekly Once",
    target: "School",
    durationHours: "30",
    targetAudience: "School Students",
    image: "/courses_images/yr_course.jpg",
    category: "Schools",
    highlights: [
      "Drone assembly, flight mechanics & engineering fundamentals",
      "Python, AI/ML concepts, automation logic & robotics basics",
      "Real-world drone applications: mapping, surveying, cinematography",
      "Data handling, troubleshooting, maintenance & safe operational practices"
    ],
    description_heading: ["NEP 2020 Aligned & Future-Ready",
       "End-to-End Execution by Our Team",
        "Structured Outcomes & Skill Development" 
        ],
    description: ["The program integrates seamlessly with STEM, AI, coding, and robotics goals outlined in NEP 2020.",
      "From weekly sessions to equipment, content, assessments, and progress reports—everything is managed by PracVerse.",
      "Students develop measurable tech competencies across drones, AI/ML, Python, and hands-on engineering throughout the year.."
    ] 
  },


  {
    id: "School_months",
    title: "Short-Term Curriculum Integration",
    shortDescriptionCover: "A 2–3 months in-school module conducted during activity periods. Cove",
    shortDescription: "A 2–3 months in-school module conducted during activity periods. Covers drone fundamentals, coding, and applied STEM to bridge classroom theory with practical learning",
    fullDescription:
      "A structured, NEP-aligned 2–3 month module conducted during school hours or activity periods. Students learn drone basics, flight mechanics, programming, and applied STEM concepts — helping them connect classroom learning with practical, real-world applications. Ideal for schools seeking short, curriculum-compatible programs",
    frequency: "1-2 times/week",
    target: "School",
    durationHours: "12-16",
    targetAudience: "School Students",
    image: "/courses_images/School_short1.png",
    category: "Schools",
    highlights: [
      "Drone basics, components & flight principles",
      "Safe flight operations, pre-flight checks & basic flying skills",
      "Introductory programming with drones (block coding & automation logic)",
      "Applied STEM learning linking science, math & real-world tech concepts"
    ],
    description_heading: ["Fits Perfectly Into School Timetables",
       "Practical Application of Classroom Concepts",
        "Clear Progress Tracking" 
        ],
    description: ["Designed for activity periods or short-term modules without disturbing regular academics",
      "Students connect science, math, and coding concepts with hands-on drone learning",
      "Schools receive updates, student progress reports, and outcomes from the program"
    ]
  },


  

  {
    id: "College_eng",
    title: "Drone Engineering & Aeronautical Systems",
    shortDescriptionCover: "A comprehensive engineering-focused program covering the design, construc",
    shortDescription: "A comprehensive engineering-focused program covering the design, construction, and analysis of UAV systems",
    fullDescription:
      "Students learn the complete lifecycle of a drone—from hardware architecture to flight mechanics and aerodynamics, including hands-on assembly of quadcopters and exposure to real-world engineering constraints.",
    frequency: "2-3 times/week", 
    target: "College",
    durationHours: "15",
    targetAudience: "College Students",
    image: "/courses_images/Drone_eng.png",
    category: "Colleges",
    highlights: [
      "Build and configure a working drone from scratch",
      "Understand engineering principles behind flight",
      "Diagnose hardware and firmware issues",
      "Apply aerodynamics for stable, optimized flight"
    ],
    description_heading: [
      "Industry-Aligned Engineering Curriculum",
      "Hands-On Labs With Zero Setup Effort",
      "Enhances Placements & Research Readiness" 
    ],
    description: [
      "The course blends UAV hardware, aerodynamics, electronics, and flight mechanics—perfectly matching outcomes expected in engineering programs (ECE, Mech, Robotics, Aero)",
      "We bring complete kits, components, safety gear, and facilitation. Colleges get ready-to-run practical labs without needing specialized drone infrastructure",
      "Students gain real project experience—building drones, analysing failures, and understanding UAV systems—making them strong candidates for robotics, defence, aerospace, and R&D roles"
    ]
  },


  {
    id: "NGO_skill",
    title: "Drone Skill Development Program",
    shortDescriptionCover: "A structured, beginner-friendly skill-building program for age",
    shortDescription: "A structured, beginner-friendly skill-building program for ages 10–20",
    fullDescription:
      "Students explore the science behind flight, basic circuits, drone handling, and block coding — while working on community-linked innovation projects that make learning meaningful",
    frequency: "2-3 times/week", 
    target: "NGO",
    durationHours: "12-16",
    targetAudience: "School & College Students",
    image: "/courses_images/NGO_skill.jpg",
    category: "NGOs",
    highlights: [
      "Group-based mini drone assembly and coding fundamentals",
      "Drone flying basics & safety principles",
      "Science of flight, circuits & sensors",
      "Small innovation projects inspired by community needs"
    ],
    description_heading: [
      "Strengthens Digital Literacy & STEM Foundations",
      "Inclusive & Impact-Focused Learning Design",
      "Scalable, Affordable, and Easy to Execute" 
    ],
    description: [
      "The program equips learners with essential digital and STEM skills through hands-on, practical activities that build confidence and curiosity",
      "Activities are crafted to engage mixed learning levels while delivering clear, measurable outcomes—making the program ideal for NGO impact assessments and reporting",
      "With low setup requirements and high flexibility, the program is cost-effective, easy to roll out across multiple locations, and perfect for large-scale community initiatives"
    ]
  },

{
    id: "Corporate_workshop",
    title: "Drone Innovation Workshop for Employee Families",
    shortDescriptionCover: "A transformative, hands-on drone technology workshop designed exclu",
    shortDescription: "A transformative, hands-on drone technology workshop designed exclusively for the children of employees",
    fullDescription:
      "This 1–2 day program blends drone building, flying, coding, and AI/ML concepts to create a powerful future-skills learning experience. Corporates can integrate this as part of CSR initiatives (Education & Skill Development) or as a high-impact Employee Engagement activity, offering employees a meaningful benefit while contributing to India’s technology-driven future",
    frequency: "1 day", 
    target: "Corporate",
    durationHours: "2-4",
    targetAudience: "School & College Students",
    image: "/courses_images/Corporate_workshop.jpg",
    category: "Corporates",
    highlights: [
      "Build and fly mini drones while learning aerodynamics and safe flight practices",
      "Program drones using block coding, Python basics, gesture control, and voice commands",
      "Explore core STEM concepts including science, engineering, electronics, AI/ML, and creativity through aerial photography",
      "Understand real-world drone applications across agriculture, logistics, security, filmmaking, and emerging tech"
    ],
    description_heading: [
      "High-Impact, Future-Skills CSR Initiative",
      "Boosts Employee Satisfaction & Employer Brand",
      "Fully Managed, Zero-Effort Implementation" 
    ],
    description: [
      "Aligned with NEP 2020 and national skill development goals, the program delivers meaningful, future-ready learning for children—making it a powerful CSR activity with real educational impact",
      "Employees appreciate a memorable, skill-building experience for their children, while companies strengthen their brand as forward-thinking, family-friendly, and socially responsible",
      "PracVerse handles everything end-to-end—content, kits, trainers, setup, and safety—ensuring a smooth, hassle-free program without any operational load on the corporate team"
    ]
  },

  {
    id: "School_workshop",
    title: "Transformative Drone Workshop",
    shortDescriptionCover: "A 2-4 hours hands-on workshop where students learn drone basics, remote",
    shortDescription: "A 2-4 hours hands-on workshop where students learn drone basics, remote controlled flying, beginner programming, and real-world applications — designed to spark curiosity instantly. ",
    fullDescription:
      "A high-impact, 4-hour experiential workshop where students explore the fundamentals of drone technology through live demonstrations, remote controlled flying, basic programming, and real-world applications. This workshop is designed to ignite curiosity, build early STEM confidence, and give students their first hands-on experience with future technologies",
    frequency: "1-2 days",
    target: "School",
    durationHours: "2-4",
    targetAudience: "School Students",
    image: "/courses_images/School_workshop1.jpg",
    category: "Schools",
    highlights: [
      "Fundamentals of drone technology & real-world applications",
      "Hands-on flying experience with safety-first protocols",
      "Basics of drone components, mechanics & aerodynamics",
      "Introduction to coding logic using simple programmable drones"
    ],
    description_heading: ["Curriculum-Relevant & Engaging",
       "Zero Operational Burden",
        "Immediate Learning Impact" 
        ],
    description: ["The workshop strengthens STEM concepts through real demonstrations of science, logic, and technology—perfectly complementing classroom learning.",
      "We handle kits, equipment, safety protocols, and facilitation. Teachers simply support coordination; we manage the rest.",
      "Students walk away with clear takeaways in flight science, safety, and basic programming—making it an ideal value-add activity."
    ]
  },


  {
    id: "School_holiday",
    title: "Holiday Tech Camps (Summer/Winter Break)",
    shortDescriptionCover: "Short-term camps that blend fun with meaningful learning. Students buil",
    shortDescription: "Short-term camps that blend fun with meaningful learning. Students build drones, fly them, program them, and explore creativity through hands-on activities.",
    fullDescription:
      "Our short-term vacation camps blend excitement with meaningful learning. Students build drones, fly them, program them with block coding & AI-based tools, and explore aerial creativity through photography and innovation challenges. These camps offer a valuable, productive break-time experience packed with fun and futuristic learning",
    frequency: "1-2 hrs/day",
    target: "School",
    durationHours: "12-16",
    targetAudience: "School Students",
    image: "/courses_images/School_monthly.jpg",
    category: "Schools",
    highlights: [
      "Build-and-fly experience with mini drones",
      "Block coding, gesture control & voice-based drone programming",
      "Aerial creativity: Drone photography & innovation challenges",
      "Hands-on STEM concepts through engaging tasks & activities"
    ]
    ,
    description_heading: ["Productive Use of Vacation Time",
       "Complete Set-Up & Management",
        "Boosts STEM Interest & Creativity" 
        ],
    description: ["High-energy, meaningful camps that make holidays educational while keeping them fun.",
      "We manage all hardware, safety, content, and facilitation—requiring minimal coordination from the school.",
      "Ideal for sparking innovation, teamwork, and early tech curiosity in students."
    ]
  },



  
  
  {
    id: "NGO_future",
    title: "Future Skills Program (Drones + Coding + AI Basics)",
    shortDescriptionCover: "A comprehensive future-skills curriculum that empowers underserved youth with empl",
    shortDescription: "A comprehensive future-skills curriculum that empowers underserved youth with employability-driven capabilities",
    fullDescription:
      "Students learn drone building, Python basics, automation, aerial data concepts, and storytelling — preparing them for the modern tech landscape.",
    frequency: "2-3 times/week", 
    target: "NGO",
    durationHours: "30",
    targetAudience: "School & College Students",
    image: "/courses_images/NGO_future.png",
    category: "NGOs",
    highlights: [
      "Learn drone assembly, engineering basics, and DGCA safety awareness",
      "Understand Python fundamentals, drone programming, and automation logic",
      "Explore gesture control, voice control, and aerial mapping with data collection",
      "Develop skills in aerial photography along with teamwork, problem-solving, and innovation"
    ],
    description_heading: [
      "Builds Future-Ready Employability Skills",
      "Designed for Teens, Seniors & Vocational Learners",
      "Measurable Impact for Donors & Communities" 
    ],
    description: [
      "The program develops essential digital, technical, and career-oriented skills aligned with NEP guidelines—supporting students in building strong employability pathways",
      "Its flexible structure works seamlessly for older students with different learning levels, making it ideal for teenagers, senior secondary students, and vocational education groups",
      "With clear learning outcomes and trackable progress, NGOs can confidently showcase improvements in confidence, digital literacy, and career readiness for donor reporting and community impact"
    ]
  },


  {
    id: "College_AI",
    title: "Drone Programming, Automation & AI-ML Applications",
    shortDescriptionCover: "A deep dive into software, coding, and intelligent automation for dro",
    shortDescription: "A deep dive into software, coding, and intelligent automation for drones",
    fullDescription:
      "Students learn how to program drones using Python, C++, MAVLink, ROS, and explore automation through gesture control, voice commands, and AI/ML-based decision systems.",
    frequency: "2-3 times/week", 
    target: "College",
    durationHours: "15",
    targetAudience: "College Students",
    image: "/courses_images/College_prog.jpg",
    category: "College",
    highlights: [
      "Write automation scripts in Python & C++",
      "Build AI-enabled drone features (gesture/voice control)",
      "Implement autonomous missions & waypoint navigation",
      "Work with simulators and real flight data"
    ],
    description_heading: [
      "Advanced Technical Rigor for CS/IT/ECE Departments",
      "Bridges Theory With Real-World Implementation",
      "Boosts Innovation, Hackathons & Tech Clubs" 
    ],
    description: [
      "Python, C++, MAVLink, ROS, AI-ML, and autonomous algorithms give students exposure to industry-standard tools used in robotics and automation research",
      "Students write actual drone software, test automation in simulators, and deploy AI-enabled controls—transforming abstract concepts into tangible outcomes",
      "Ideal for incubation cells, coding societies, and research labs—this program stimulates student-led innovation, projects, and competition participation (Smart India Hackathon, DRDO challenges, UAV contests)"
    ]
  },

  
  {
    id: "School_competition",
    title: "Inter-School Drone Competition Program",
    shortDescriptionCover: "Drone-building, flying, and coding challenges for schools to host or participate in ",
    shortDescription: "Drone-building, flying, and coding challenges for schools to host or participate in - encouraging teamwork, problem-solving, and innovation",
    fullDescription:
      "A dynamic competition-based offering where schools host or participate in drone-based challenges. Students design, build, program, and fly drones through tasks that build creativity, teamwork, critical thinking, and technological confidence",
    frequency: "1-2 days",
    target: "School",
    durationHours: "2-4",
    targetAudience: "School Students",
    image: "/courses_images/School_competition.jpg",
    category: "School",
    highlights: [
      "Design-thinking applied to drone building & customization",
      "Competition-level flying skills, precision control & obstacle navigation",
      "Programming drones for specific tasks & challenge-based missions",
      "Teamwork, strategy development & problem-solving under constraints"
    ],
    description_heading: ["Builds a Strong STEM Culture",
       "Ready-to-Run Competition Format",
        "Showcases Student Talent" 
        ],
    description: ["Competitions spark excitement, teamwork, problem-solving, and innovation across the school community",
      "We provide challenge designs, rules, training, equipment, and facilitation—schools only host or participate",
      "A great platform for students to demonstrate skills in engineering, coding, flying, and strategy"
    ]
  },

  
  
  {
    id: "College_flying",
    title: "Drone Flying, Data Analysis & Cloud-Based Aerial Intelligence",
    shortDescriptionCover: "A practice-heavy course where students master manual flying, remote piloting ski",
    shortDescription: "A practice-heavy course where students master manual flying, remote piloting skills, aerial photography, cinematography, and then progress into data collection, processing, and cloud analytics",
    fullDescription:
      "A practice-heavy course where students master manual flying, remote piloting skills, aerial photography, cinematography, and then progress into data collection, processing, and cloud analytics used in industries like precision farming, mapping, surveying, disaster management, and logistics",
    frequency: "2-3 times/week", 
    target: "College",
    durationHours: "15",
    targetAudience: "College Students",
    image: "/courses_images/College_flying.jpg",
    category: "College",
    highlights: [
      "Become confident in manual + automated drone flying",
      "Capture high-quality aerial photos/videos",
      "Process drone-collected data for mapping & analytics",
      "Understand real industry use case"
    ],
    description_heading: [
      "Strong Industry Application Focus",
      "Skill Development Beyond Classroom Theory",
      "Perfect for Multi-Disciplinary Departments" 
    ],
    description: [
      "Data processing, mapping, cloud workflows, and analytics match the needs of core sectors—agri-tech, mining, logistics, surveying, urban planning, and disaster management",
      "Students practice real flying, capture aerial data, and learn how industries extract insights—closing the gap between academic knowledge and job-ready competence",
      "Useful for engineering, GIS, management, agriculture tech, and analytics programs. Colleges appreciate its versatility and relevance across faculties"
    ]
  },


{
    id: "NGO_workshop",
    title: "Drone Discovery Workshop",
    shortDescriptionCover: "A fun, high-energy introduction to drone technology designed for children an",
    shortDescription: "A fun, high-energy introduction to drone technology designed for children and youth from underserved communities",
    fullDescription:
      "This short-format workshop blends demonstrations, basic flying exposure, creativity challenges, and real-world applications — helping learners experience future technology in an accessible and inspiring way",
    frequency: "1-2 days", 
    target: "NGO",
    durationHours: "2-4",
    targetAudience: "School & College Students",
    image: "/courses_images/NGO_discovery.png",
    category: "NGOs",
    highlights: [
      "Basics of drones, aerodynamics & components",
      "Live flying demos with safety awareness",
      "Hands-on mini challenges & teamwork tasks",
      "Real-use cases: agriculture, relief work, filmmaking, delivery tech"
    ],
    description_heading: [
      "High-Impact STEM Learning for All Age Groups",
      "Completely Hassle-Free — We Bring Everything",
      "Ideal for Donor Events & Community Engagement" 
    ],
    description: [
      "Our workshop delivers short yet powerful learning experiences that work perfectly for mixed-age groups and large batches. Kids quickly gain curiosity, confidence, and a strong interest in STEM through hands-on drone activities",
      "NGOs love that the entire program is zero-setup. All materials, equipment, and activity kits are provided by us, making it easy to conduct sessions anywhere without logistical challenges",
      "The program is perfectly suited for donor-led initiatives, exposure visits, and community outreach. It creates an engaging, visually appealing learning environment that showcases real impact"
    ]
  },
  
  
  {
    id: "NGO_youth",
    title: "Youth Career Pathway Program (Technical Track)",
    shortDescriptionCover: "A job-oriented technical program for youth aged 16–25, focused on preparing th",
    shortDescription: "A job-oriented technical program for youth aged 16–25, focused on preparing them for real industry roles",
    fullDescription:
      "A job-oriented technical program for youth aged 16–25, focused on preparing them for real industry roles such as drone operators, mapping assistants, technicians, and field support staff. Combines technical knowledge with hands-on flying, data skills, and industry use cases",
    frequency: "2-3 times/week", 
    target: "NGO",
    durationHours: "16",
    targetAudience: "School & College Students",
    image: "/courses_images/NGO_youth.png",
    category: "NGOs",
    highlights: [
      "Master drone piloting fundamentals with industry-standard safety and regulatory practices",
      "Learn surveying, mapping, and GIS essentials for real-world field operations",
      "Understand data collection, processing, analysis, and cloud-based drone workflows",
      "Explore practical drone applications across agriculture, mining, logistics, and security"
    ],
    description_heading: [
      "Directly Drives Employability & Livelihood Outcomes",
      "Fully Aligned With National Skilling & Youth Missions",
      "Perfect Fit for Vocational Centers & Youth-Focused NGOs" 
    ],
    description: [
      "The program strengthens future career pathways by preparing learners with industry-relevant drone and tech skills that support long-term livelihood goals.",
      "Built to match government skilling priorities, the program supports youth development initiatives and equips students for a wide range of drone-industry job roles",
      "With strong real-world relevance and proven industry credibility, the program is ideal for vocational training centers, skill academies, and NGOs focused on empowering young adults"
    ]
  },

  
];
